import React, { useState, useContext } from 'react';
import '../personalisationModal/personalisationModal.css';
import cross from '../assets/x-solid.svg';
import { ShopContext } from '../../context/shopContext';

const PersonalisationCartModal = (props) => {
    const { closePersonalisationCartModal } = props;
    const { updatePersonalisationInCart } = useContext(ShopContext);

    const [text, setText] = useState(props.existingPersonalisation || '');

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const remainingCharacters = 100 - text.length;
    const itemId = props.id;
    const index = props.index;

const handleAddMessageClick = async () => {
    await updatePersonalisationInCart({ index, itemId, personalisation: text });
    closePersonalisationCartModal(false);
    window.location.reload(); // Only reload AFTER the fetch finishes
};


    return (
        <div className='modal-background'>
            <div className='modal-cancel-background' onClick={() => closePersonalisationCartModal(false)}></div>

            <div className='modal-container'>
                <img className='exit-btn' onClick={() => closePersonalisationCartModal(false)} src={cross} alt="" />
                <div className='personalisation-textarea-container'>
                    <textarea
                        className='personalisation-textarea'
                        type="textarea"
                        name="personalisation"
                        id=""
                        maxLength="100"
                        value={text}
                        onChange={handleChange}
                        placeholder='Do your worst, peasant'
                    />
                </div>
                <p className='character-count'>Characters remaining: {remainingCharacters}</p>
                <button onClick={handleAddMessageClick}>Save Message</button>
            </div>
        </div>
    );
};

export default PersonalisationCartModal;
